module.exports = __webpack_public_path__ + "static/img/14.b1837f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/14.png
// module id = 74A+
// module chunks = 0